import { createAction } from '@reduxjs/toolkit'

export const openWallet = createAction('wallet/openWallet')
export const closeWallet = createAction('wallet/closeWallet')
